export enum RespondentPageStatus {
  new = 'New',
  started = 'Started',
  needsReview = 'Needs Review',
  ready = 'Ready',
  pendingResponse = 'Pending Response',
  changesDetected = 'ChangesDetected',
  complete = 'Complete',
}
